<template>
  <div class="current-plan-card-section">
    <h4 v-if="sectionTitle !== ''" class="current-plan-card-section__title" v-html="sectionTitle" />

    <div class="current-plan-card-section__plan">
      <coupon-plan-card-parts
        v-if="'couponData' in plan"
        :plan="plan"
        :isOneTimePassUsed="isOneTimePassUsed"
      />
      <plan-card-parts
        v-else
        :plan="plan"
        :isConfirmed="isConfirmed"
        :contractTerm="contractTerm"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import CouponPlanCardParts from '@/components/SignupPage/common/CouponPlanCardParts.vue'
import PlanCardParts from '@/components/SignupPage/common/PlanCardParts.vue'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'
import type { ContractTermType } from '@/store/stores/collectionModule/documents/GeneralTypes'

/**
 * 新規会員登録 プラン比較
 */
export default defineComponent({
  name: 'CurrentPlanCardSection',
  components: {
    CouponPlanCardParts,
    PlanCardParts,
  },
  props: {
    /**
     * 表示するプラン
     */
    plan: {
      type: Object as PropType<ContractPlanDocument>,
      default: null,
    },
    /**
     * 表示するタイトル
     */
    sectionTitle: {
      type: String,
      default: '',
    },
    /**
     * ワイタイムパスかどうか
     */
    isOneTimePassUsed: {
      type: Boolean,
      default: false,
    },
    /**
     * 確認画面かどうか
     */
    isConfirmed: {
      type: Boolean,
      default: false,
    },
    /**
     * 契約中のプランの契約期間
     */
    contractTerm: {
      type: Object as PropType<ContractTermType>,
      default: null,
    },
  },
})
</script>

<style lang="scss" scoped>
.current-plan-card-section {
  width: 100%;
  padding: 24px 16px;

  &__title {
    margin-bottom: 24px;
    font-weight: 500;
    font-size: 17px;
    line-height: 1.41;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray75;
  }

  &__plan {
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    padding: 8px 10px 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;

    @media screen and (min-width: $responsiveTabletWidth) {
      padding: 10px;
    }
  }
}
</style>
